export const TheTrustAction = {
  GET_THE_TRUST_INFO_MSG: "GET_THE_TRUST_INFO_MSG",
  SET_THE_TRUST_INFO_MSG: "SET_THE_TRUST_INFO_MSG",
};
